import { authApi } from '../redux/api/adminApi/authApi';
import { logOut, setInitialFetching } from '../redux/reducers/authSlice';
import { resetChatStore } from '../redux/reducers/chatAdminSlice';
import { store } from '../redux/store';
import { ELocalStorage, EToken } from '../types/localStorageTypes';
import { getTokenByType } from '../utils/localStorageUtil';
import { getLocalStorageService } from './localStorageService';

export const authServiceSetting = async () => {
  const dispatch = store.dispatch;
  if (getLocalStorageService(EToken.TOKENS)) {
    await dispatch(authApi.endpoints.recoveryUser.initiate(undefined, undefined));
    store.dispatch(resetChatStore());
  }
  dispatch(setInitialFetching(true));
};

export const authService = async () => {
  const dispatch = store.dispatch;
  const initialFetching = store.getState().auth.initialFetching;

  const adminAccessToken = getTokenByType(ELocalStorage.AdminAccessToken);
  const adminRefreshToken = getTokenByType(ELocalStorage.AdminRefreshToken);

  if (adminAccessToken && adminRefreshToken) {
    if (initialFetching) {
      await dispatch(authApi.endpoints.recoveryUser.initiate(undefined, undefined));
      store.dispatch(resetChatStore());
    }
  } else {
    dispatch(logOut());
  }
};
